import { createStore, applyMiddleware, compose } from 'redux'
import { createBrowserHistory, createMemoryHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'

import createMiddleware from './middleware/clientMiddleware'

/**
 * This methods creates a redux store based on the root reducer.
 * It can be enhanced by middleware, like redux-thunk or redux-devtools.
 *
 * For more information on the store, see https://redux.js.org/docs/basics/Store.html
 */
export default (preloadedState, client, url, params) => {
  const history = prepareHistory(url)

  const middleware = prepareMiddleware(client, history)

  const enhancer = prepareEnhancer(middleware)

  const reducer = require('./modules/reducer').default(history, params)

  const store = createStore(reducer, preloadedState, enhancer)

  // this piece of code enables hot reload of state with redux
  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./modules/reducer', () => {
      store.replaceReducer(require('./modules/reducer').default(params))
    })
  }

  return { store, history }
}


function prepareHistory(url) {
  if (__SERVER__) {
    // since the server has no HTML5 push states,
    // history must be temporarily created in memory
    return createMemoryHistory({
      initialEntries: [url],
    })
  } else {
    // on the client, we can go ahead and make a standard
    // `history` state
    return createBrowserHistory()
  }
}


function prepareMiddleware(client, history) {
  const middleware = []

  middleware.push(createMiddleware(client))
  middleware.push(routerMiddleware(history))

  return middleware
}


function prepareEnhancer(middleware) {
  const composeEnhancers = (__DEVELOPMENT__
    && typeof window !== 'undefined'
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    || compose

  const subEnhancers = []

  subEnhancers.push(applyMiddleware(...middleware))

  return composeEnhancers(...subEnhancers)
}
